import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StockState } from "src/types/stock.types";

const initialState: StockState = {
  stockLevelList: {
    loading: false,
    data: null,
    error: null,
  },
  adjustStock: {
    loading: false,
    data: null,
    error: null,
  },
  stockTransferList: {
    loading: false,
    data: null,
    error: null,
  },
  createStockTransfer: {
    loading: false,
    data: null,
    error: null,
  },
};

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    // get stock level list
    getStockLevelListRequest: (state, action: PayloadAction<any>) => {
      state.stockLevelList.loading = true;
      state.stockLevelList.data = null;
      state.stockLevelList.error = null;
    },
    getStockLevelListSuccess: (state, action: PayloadAction<any>) => {
      state.stockLevelList.loading = false;
      state.stockLevelList.data = action.payload;
      state.stockLevelList.error = null;
    },
    getStockLevelListError: (state, action: PayloadAction<string>) => {
      state.stockLevelList.loading = false;
      state.stockLevelList.data = null;
      state.stockLevelList.error = action.payload;
    },
    resetStockLevelList: (state) => {
      state.stockLevelList = { loading: false, data: null, error: null };
    },

    // adjust stock
    adjustStockRequest: (state, action: PayloadAction<any>) => {
      state.adjustStock.loading = true;
      state.adjustStock.data = null;
      state.adjustStock.error = null;
    },
    adjustStockSuccess: (state, action: PayloadAction<any>) => {
      state.adjustStock.loading = false;
      state.adjustStock.data = action.payload;
      state.adjustStock.error = null;
    },
    adjustStockError: (state, action: PayloadAction<string>) => {
      state.adjustStock.loading = false;
      state.adjustStock.data = null;
      state.adjustStock.error = action.payload;
    },
    resetAdjustStock: (state) => {
      state.adjustStock = { loading: false, data: null, error: null };
    },

    // get stock transfer list
    getStockTransferListRequest: (state, action: PayloadAction<any>) => {
      state.stockTransferList.loading = true;
      state.stockTransferList.data = null;
      state.stockTransferList.error = null;
    },
    getStockTransferListSuccess: (state, action: PayloadAction<any>) => {
      state.stockTransferList.loading = false;
      state.stockTransferList.data = action.payload;
      state.stockTransferList.error = null;
    },
    getStockTransferListError: (state, action: PayloadAction<string>) => {
      state.stockTransferList.loading = false;
      state.stockTransferList.data = null;
      state.stockTransferList.error = action.payload;
    },
    resetStockTransferList: (state) => {
      state.stockTransferList = { loading: false, data: null, error: null };
    },

    // create stock transfer
    createStockTransferRequest: (state, action: PayloadAction<any>) => {
      state.createStockTransfer.loading = true;
      state.createStockTransfer.data = null;
      state.createStockTransfer.error = null;
    },
    createStockTransferSuccess: (state, action: PayloadAction<any>) => {
      state.createStockTransfer.loading = false;
      state.createStockTransfer.data = action.payload;
      state.createStockTransfer.error = null;
    },
    createStockTransferError: (state, action: PayloadAction<string>) => {
      state.createStockTransfer.loading = false;
      state.createStockTransfer.data = null;
      state.createStockTransfer.error = action.payload;
    },
    resetCreateStockTransfer: (state) => {
      state.createStockTransfer = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getStockLevelListRequest,
  getStockLevelListSuccess,
  getStockLevelListError,
  resetStockLevelList,

  adjustStockRequest,
  adjustStockSuccess,
  adjustStockError,
  resetAdjustStock,

  getStockTransferListRequest,
  getStockTransferListSuccess,
  getStockTransferListError,
  resetStockTransferList,

  createStockTransferRequest,
  createStockTransferSuccess,
  createStockTransferError,
  resetCreateStockTransfer,
} = stockSlice.actions;

export default stockSlice.reducer;
